import { Avatar as AvatarPrimitive } from 'radix-ui';
import { cn } from '../../lib/cn.js';
import { initials } from '../../lib/format.js';

export interface AvatarProps {
  name: string;
  src?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZES = { sm: 'size-7 text-[11px]', md: 'size-9 text-helper', lg: 'size-11 text-body' } as const;

export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  return (
    <AvatarPrimitive.Root
      className={cn('inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-pill bg-brand-tint font-semibold text-brand-hover', SIZES[size], className)}
    >
      {src ? <AvatarPrimitive.Image src={src} alt={name} className="size-full object-cover" /> : null}
      <AvatarPrimitive.Fallback aria-label={name} delayMs={src ? 300 : 0}>
        {initials(name)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
